import { cartDetailsUrl } from '../../currentCart';
import errorHandler from '../../errorHandler';
import { getItemDiscount } from '../../utils/item';
import setupShopifyCartHook from './hook';
import injectStyles from './styles';
import { setHookCheckoutItems } from './utils';
import { injectLineSubtotal, injectSubtotal } from './hooks/themes/utils';

function getData() {
  return new Promise(resolve => {
    try {
      jUpsell.getJSON(cartDetailsUrl, function(result) {
        resolve(result);
      });
    } catch (err) {
      errorHandler(err);
    }
  });
}

export default function cartPageInjector() {
  injectStyles();

  getData()
    .then(v => {
      let subtotalOriginal = 0;
      let subtotal = 0;
      const items = v.items;

      setHookCheckoutItems(items);

/*      items.forEach((v, i) => {
        const { price, quantity } = v;

        let discount = getItemDiscount(v);

        const correctedPrice = price / 100;
        const qt = quantity;

        const iter = i + 1;

        const cost = correctedPrice - (correctedPrice / 100) * discount;
        const totalPrice = cost * qt;

        const originalCost = correctedPrice;
        const totalOriginalPrice = originalCost * qt;

        if (discount > 0) {
          injectLineSubtotal({
            item: v,
            iter,
            cost,
            totalPrice
          });
        }

        subtotalOriginal = subtotalOriginal + totalOriginalPrice;
        subtotal = subtotal + totalPrice;
      });

      injectSubtotal({ subtotalOriginal, subtotal });*/
      setupShopifyCartHook();
    })
    .catch({});
}
